// Chromium browsers also claim "Safari" and are excluded by their own token;
// every other browser that claims it runs on WebKit (all of iOS included).
const SAFARI = /^((?!chrome|chromium|android).)*safari/i;

/** Safari or another WebKit browser, by user agent. */
export const isSafari = (): boolean => SAFARI.test(window.navigator.userAgent);
